//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class UsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Request to send invitation is accepted
     */
    invite(request: InviteRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/invitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvite(_response);
        });
    }

    protected processInvite(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Validation errors have occured", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Request to send invitation is accepted
     */
    selfInvite(request: InviteRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/invitation/self";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSelfInvite(_response);
        });
    }

    protected processSelfInvite(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Validation errors have occured", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Validates an invitation token
     * @param invitationToken Token
     * @return The invitation token was found
     */
    validateInvitationToken(invitationToken: string, cancelToken?: CancelToken): Promise<ValidatedInvitation> {
        let url_ = this.baseUrl + "/api/cp/users/invitation/{invitationToken}";
        if (invitationToken === undefined || invitationToken === null)
            throw new Error("The parameter 'invitationToken' must be defined.");
        url_ = url_.replace("{invitationToken}", encodeURIComponent("" + invitationToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateInvitationToken(_response);
        });
    }

    protected processValidateInvitationToken(response: AxiosResponse): Promise<ValidatedInvitation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("The invitation token was not found", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Invitation was found, but has already been fulfilled", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidatedInvitation.fromJS(resultData200);
            return Promise.resolve<ValidatedInvitation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidatedInvitation>(null as any);
    }

    /**
     * Registers a customer portal user through an invitation token
     * @param userTokenRegistration The information needed to register a user
     */
    register(userTokenRegistration: UserTokenRegistration, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userTokenRegistration);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Invitation not found", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Validation errors occured", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Authenticate a customer portal user with a Microsoft token
     * @param idToken JWT issued by Microsoft
     * @return Authentication was successful
     */
    authenticateWithMicrosoft(idToken: string, cancelToken?: CancelToken): Promise<SuccessfulAuthenticationResponse> {
        let url_ = this.baseUrl + "/api/cp/users/authenticate/microsoft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idToken);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticateWithMicrosoft(_response);
        });
    }

    protected processAuthenticateWithMicrosoft(response: AxiosResponse): Promise<SuccessfulAuthenticationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SuccessfulAuthenticationResponse.fromJS(resultData200);
            return Promise.resolve<SuccessfulAuthenticationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessfulAuthenticationResponse>(null as any);
    }

    /**
     * Authenticate a customer portal user with a Google token
     * @param idToken JWT issued by Google
     * @return Authentication was successful
     */
    authenticateWithGoogle(idToken: string, cancelToken?: CancelToken): Promise<SuccessfulAuthenticationResponse> {
        let url_ = this.baseUrl + "/api/cp/users/authenticate/google";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idToken);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticateWithGoogle(_response);
        });
    }

    protected processAuthenticateWithGoogle(response: AxiosResponse): Promise<SuccessfulAuthenticationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SuccessfulAuthenticationResponse.fromJS(resultData200);
            return Promise.resolve<SuccessfulAuthenticationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessfulAuthenticationResponse>(null as any);
    }

    getGoogleOneTapIframeUrl( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/cp/users/google/iframe-url";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGoogleOneTapIframeUrl(_response);
        });
    }

    protected processGetGoogleOneTapIframeUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getMicrosoftAuthOptions( cancelToken?: CancelToken): Promise<MicrosoftAuthOptionsResponse> {
        let url_ = this.baseUrl + "/api/cp/users/microsoft/auth-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMicrosoftAuthOptions(_response);
        });
    }

    protected processGetMicrosoftAuthOptions(response: AxiosResponse): Promise<MicrosoftAuthOptionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MicrosoftAuthOptionsResponse.fromJS(resultData200);
            return Promise.resolve<MicrosoftAuthOptionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MicrosoftAuthOptionsResponse>(null as any);
    }

    /**
     * Authenticate a customer portal user
     * @param authenticationInfo The login and password information
     * @return Authentication was successful
     */
    authenticate(authenticationInfo: AuthenticationInfo, cancelToken?: CancelToken): Promise<SuccessfulAuthenticationResponse> {
        let url_ = this.baseUrl + "/api/cp/users/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authenticationInfo);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: AxiosResponse): Promise<SuccessfulAuthenticationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SuccessfulAuthenticationResponse.fromJS(resultData200);
            return Promise.resolve<SuccessfulAuthenticationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessfulAuthenticationResponse>(null as any);
    }

    /**
     * Validate authenticated customer portal user
     * @return User info is returned
     */
    validate( cancelToken?: CancelToken): Promise<UserInfo> {
        let url_ = this.baseUrl + "/api/cp/users/validate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidate(_response);
        });
    }

    protected processValidate(response: AxiosResponse): Promise<UserInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserInfo.fromJS(resultData200);
            return Promise.resolve<UserInfo>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("User is not authenticated", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("User is authenticated but info cannot be found or the user is inactive", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInfo>(null as any);
    }

    getInvitations(contactMethod: string[] | undefined, cancelToken?: CancelToken): Promise<CustomerInvitationResult> {
        let url_ = this.baseUrl + "/api/cp/users/invitations?";
        if (contactMethod === null)
            throw new Error("The parameter 'contactMethod' cannot be null.");
        else if (contactMethod !== undefined)
            contactMethod && contactMethod.forEach(item => { url_ += "contactMethod=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvitations(_response);
        });
    }

    protected processGetInvitations(response: AxiosResponse): Promise<CustomerInvitationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerInvitationResult.fromJS(resultData200);
            return Promise.resolve<CustomerInvitationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerInvitationResult>(null as any);
    }

    /**
     * @return Successfully accepted request of the password reset link
     */
    sendPasswordResetLink(request: SendPasswordResetLinkRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/password-resets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendPasswordResetLink(_response);
        });
    }

    protected processSendPasswordResetLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("Validation errors occured", status, _responseText, _headers);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Successfully accepted request of the password reset link
     */
    selfSendPasswordResetLink(request: SendPasswordResetLinkRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/password-resets/self";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSelfSendPasswordResetLink(_response);
        });
    }

    protected processSelfSendPasswordResetLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("Validation errors occured", status, _responseText, _headers);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Password reset token has not expired
     */
    validatePasswordResetToken(token: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/password-resets/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidatePasswordResetToken(_response);
        });
    }

    protected processValidatePasswordResetToken(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Password token expired", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates the users password using a reset token
     * @param token The password reset token
     * @param newPasswordModel The data required to reset the password
     * @return Successfully updated the password
     */
    updatePassword(token: string, newPasswordModel: NewPasswordModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/passwords/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newPasswordModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePassword(_response);
        });
    }

    protected processUpdatePassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("The specified token is invalid", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("The new password does not match the requirements", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Log out authenticated user
     * @return User is signed out
     */
    logout( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Returned user permissions
     * @deprecated
     */
    getUserPermissions(userEmail: string, cancelToken?: CancelToken): Promise<UserPermissionModelV1[]> {
        let url_ = this.baseUrl + "/api/cp/users/permissions/user/{userEmail}";
        if (userEmail === undefined || userEmail === null)
            throw new Error("The parameter 'userEmail' must be defined.");
        url_ = url_.replace("{userEmail}", encodeURIComponent("" + userEmail));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserPermissions(_response);
        });
    }

    protected processGetUserPermissions(response: AxiosResponse): Promise<UserPermissionModelV1[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPermissionModelV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserPermissionModelV1[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Could not find user by email", status, _responseText, _headers);

        } else if (status === 409) {
            const _responseText = response.data;
            return throwException("Found more than one user by email", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserPermissionModelV1[]>(null as any);
    }

    /**
     * @param userEmail (optional) 
     * @return Returned user permissions
     * @deprecated
     */
    getUserPermissionsByEmailsV1(userEmail: string[] | undefined, cancelToken?: CancelToken): Promise<UserPermissionModelV1[]> {
        let url_ = this.baseUrl + "/api/cp/users/permissions/contactMethods?";
        if (userEmail === null)
            throw new Error("The parameter 'userEmail' cannot be null.");
        else if (userEmail !== undefined)
            userEmail && userEmail.forEach(item => { url_ += "userEmail=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserPermissionsByEmailsV1(_response);
        });
    }

    protected processGetUserPermissionsByEmailsV1(response: AxiosResponse): Promise<UserPermissionModelV1[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPermissionModelV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserPermissionModelV1[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("User not found by email", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserPermissionModelV1[]>(null as any);
    }

    /**
     * @param userEmail (optional) 
     * @return Returned user permissions
     */
    getUserPermissionsByEmails(userEmail: string[] | undefined, cancelToken?: CancelToken): Promise<UserPermissionModelV2[]> {
        let url_ = this.baseUrl + "/api/cp/users/permissions/emails?";
        if (userEmail === null)
            throw new Error("The parameter 'userEmail' cannot be null.");
        else if (userEmail !== undefined)
            userEmail && userEmail.forEach(item => { url_ += "userEmail=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserPermissionsByEmails(_response);
        });
    }

    protected processGetUserPermissionsByEmails(response: AxiosResponse): Promise<UserPermissionModelV2[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPermissionModelV2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserPermissionModelV2[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("User not found by email", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserPermissionModelV2[]>(null as any);
    }

    /**
     * @return Returned user permissions
     */
    getCurrentUserPermissions( cancelToken?: CancelToken): Promise<UserPermissionModelV2[]> {
        let url_ = this.baseUrl + "/api/cp/users/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentUserPermissions(_response);
        });
    }

    protected processGetCurrentUserPermissions(response: AxiosResponse): Promise<UserPermissionModelV2[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPermissionModelV2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserPermissionModelV2[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("User not found by email", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserPermissionModelV2[]>(null as any);
    }

    /**
     * @return Successfully updated user permissions
     * @deprecated
     */
    putPermissions(permissions: UserPermissionModelV1[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/permissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permissions);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutPermissions(_response);
        });
    }

    protected processPutPermissions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Successfully updated user permissions
     */
    putPermissionsV2(permissions: UserPermissionModelV2[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/v2/permissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permissions);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutPermissionsV2(_response);
        });
    }

    protected processPutPermissionsV2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userEmail (optional) 
     * @return User with email address no longer exists
     */
    removeUser(userEmail: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/user?";
        if (userEmail === null)
            throw new Error("The parameter 'userEmail' cannot be null.");
        else if (userEmail !== undefined)
            url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveUser(_response);
        });
    }

    protected processRemoveUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Performs a one-time migration of users from CP1 to CP2
     * @return Successfully migrated cp1 users
     */
    migrateCp1Users( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/migration/cp1";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMigrateCp1Users(_response);
        });
    }

    protected processMigrateCp1Users(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class InviteRequest implements IInviteRequest {
    contactValue!: string;

    constructor(data?: IInviteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactValue = _data["contactValue"];
        }
    }

    static fromJS(data: any): InviteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactValue"] = this.contactValue;
        return data;
    }
}

export interface IInviteRequest {
    contactValue: string;
}

/** Information returned when invite is valid */
export class ValidatedInvitation implements IValidatedInvitation {
    /** Suggested username, has value null when it's already taken */
    contactValue!: string | undefined;
    contactMethod!: ContactMethod;

    constructor(data?: IValidatedInvitation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactValue = _data["contactValue"];
            this.contactMethod = _data["contactMethod"];
        }
    }

    static fromJS(data: any): ValidatedInvitation {
        data = typeof data === 'object' ? data : {};
        let result = new ValidatedInvitation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactValue"] = this.contactValue;
        data["contactMethod"] = this.contactMethod;
        return data;
    }
}

/** Information returned when invite is valid */
export interface IValidatedInvitation {
    /** Suggested username, has value null when it's already taken */
    contactValue: string | undefined;
    contactMethod: ContactMethod;
}

export enum ContactMethod {
    Email = 0,
    PhoneNumber = 1,
}

export class UserTokenRegistration implements IUserTokenRegistration {
    user!: UserRegistration;
    invitationToken!: string;

    constructor(data?: IUserTokenRegistration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserRegistration.fromJS(_data["user"]) : <any>undefined;
            this.invitationToken = _data["invitationToken"];
        }
    }

    static fromJS(data: any): UserTokenRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new UserTokenRegistration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["invitationToken"] = this.invitationToken;
        return data;
    }
}

export interface IUserTokenRegistration {
    user: UserRegistration;
    invitationToken: string;
}

export class UserRegistration implements IUserRegistration {
    userName!: string;
    password!: string;

    constructor(data?: IUserRegistration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): UserRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new UserRegistration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface IUserRegistration {
    userName: string;
    password: string;
}

export class SuccessfulAuthenticationResponse implements ISuccessfulAuthenticationResponse {
    type!: LoginType;

    constructor(data?: ISuccessfulAuthenticationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SuccessfulAuthenticationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SuccessfulAuthenticationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        return data;
    }
}

export interface ISuccessfulAuthenticationResponse {
    type: LoginType;
}

/** Login type */
export enum LoginType {
    Restricted = 1,
    Full = 2,
}

export class MicrosoftAuthOptionsResponse implements IMicrosoftAuthOptionsResponse {
    clientId!: string;
    authority!: string;
    redirectUri!: string;

    constructor(data?: IMicrosoftAuthOptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.authority = _data["authority"];
            this.redirectUri = _data["redirectUri"];
        }
    }

    static fromJS(data: any): MicrosoftAuthOptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftAuthOptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["authority"] = this.authority;
        data["redirectUri"] = this.redirectUri;
        return data;
    }
}

export interface IMicrosoftAuthOptionsResponse {
    clientId: string;
    authority: string;
    redirectUri: string;
}

export class AuthenticationInfo implements IAuthenticationInfo {
    username!: string;
    password!: string;
    keepSigned!: boolean;

    constructor(data?: IAuthenticationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.keepSigned = _data["keepSigned"];
        }
    }

    static fromJS(data: any): AuthenticationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["keepSigned"] = this.keepSigned;
        return data;
    }
}

export interface IAuthenticationInfo {
    username: string;
    password: string;
    keepSigned: boolean;
}

export class UserInfo implements IUserInfo {
    userId!: number;
    userName!: string;
    propertyOwnerType!: PropertyOwnerType;
    loginType!: LoginType;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.propertyOwnerType = _data["propertyOwnerType"];
            this.loginType = _data["loginType"];
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["propertyOwnerType"] = this.propertyOwnerType;
        data["loginType"] = this.loginType;
        return data;
    }
}

export interface IUserInfo {
    userId: number;
    userName: string;
    propertyOwnerType: PropertyOwnerType;
    loginType: LoginType;
}

export enum PropertyOwnerType {
    Commercial = 1,
    Residential = 2,
}

export class CustomerInvitationResult implements ICustomerInvitationResult {
    invitations!: CustomerInvitation[];

    constructor(data?: ICustomerInvitationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invitations"])) {
                this.invitations = [] as any;
                for (let item of _data["invitations"])
                    this.invitations!.push(CustomerInvitation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerInvitationResult {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerInvitationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invitations)) {
            data["invitations"] = [];
            for (let item of this.invitations)
                data["invitations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomerInvitationResult {
    invitations: CustomerInvitation[];
}

export class CustomerInvitation implements ICustomerInvitation {
    contactValue!: string;
    inviteSentDate!: Date;
    lastSignInDate!: Date | undefined;
    status!: CustomerInvitationStatus;
    inviteLink!: string | undefined;

    constructor(data?: ICustomerInvitation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactValue = _data["contactValue"];
            this.inviteSentDate = _data["inviteSentDate"] ? new Date(_data["inviteSentDate"].toString()) : <any>undefined;
            this.lastSignInDate = _data["lastSignInDate"] ? new Date(_data["lastSignInDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.inviteLink = _data["inviteLink"];
        }
    }

    static fromJS(data: any): CustomerInvitation {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerInvitation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactValue"] = this.contactValue;
        data["inviteSentDate"] = this.inviteSentDate ? this.inviteSentDate.toISOString() : <any>undefined;
        data["lastSignInDate"] = this.lastSignInDate ? this.lastSignInDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["inviteLink"] = this.inviteLink;
        return data;
    }
}

export interface ICustomerInvitation {
    contactValue: string;
    inviteSentDate: Date;
    lastSignInDate: Date | undefined;
    status: CustomerInvitationStatus;
    inviteLink: string | undefined;
}

export enum CustomerInvitationStatus {
    Invited = 1,
    Active = 2,
    Expired = 3,
}

export class SendPasswordResetLinkRequest implements ISendPasswordResetLinkRequest {
    username!: string;

    constructor(data?: ISendPasswordResetLinkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): SendPasswordResetLinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetLinkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data;
    }
}

export interface ISendPasswordResetLinkRequest {
    username: string;
}

export class NewPasswordModel implements INewPasswordModel {
    /** The new password to set */
    newPassword!: Password;

    constructor(data?: INewPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"] ? Password.fromJS(_data["newPassword"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NewPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword ? this.newPassword.toJSON() : <any>undefined;
        return data;
    }
}

export interface INewPasswordModel {
    /** The new password to set */
    newPassword: Password;
}

export class Password implements IPassword {
    value!: string;

    constructor(data?: IPassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Password {
        data = typeof data === 'object' ? data : {};
        let result = new Password();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IPassword {
    value: string;
}

export class UserPermissionModelV1 implements IUserPermissionModelV1 {
    id!: number | undefined;
    userId!: number;
    entityId!: number;
    entityType!: UserPermissionEntityType;
    permissionType!: UserPermissionType;

    constructor(data?: IUserPermissionModelV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.entityId = _data["entityId"];
            this.entityType = _data["entityType"];
            this.permissionType = _data["permissionType"];
        }
    }

    static fromJS(data: any): UserPermissionModelV1 {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionModelV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["entityId"] = this.entityId;
        data["entityType"] = this.entityType;
        data["permissionType"] = this.permissionType;
        return data;
    }
}

export interface IUserPermissionModelV1 {
    id: number | undefined;
    userId: number;
    entityId: number;
    entityType: UserPermissionEntityType;
    permissionType: UserPermissionType;
}

export enum UserPermissionEntityType {
    Customer = 1,
    Location = 2,
}

export enum UserPermissionType {
    None = 0,
    Read = 1,
    Billing = 2,
}

export class UserPermissionModelV2 implements IUserPermissionModelV2 {
    id!: number | undefined;
    email!: string;
    entityId!: number;
    entityType!: UserPermissionEntityType;
    permissionType!: UserPermissionType;

    constructor(data?: IUserPermissionModelV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.entityId = _data["entityId"];
            this.entityType = _data["entityType"];
            this.permissionType = _data["permissionType"];
        }
    }

    static fromJS(data: any): UserPermissionModelV2 {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionModelV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["entityId"] = this.entityId;
        data["entityType"] = this.entityType;
        data["permissionType"] = this.permissionType;
        return data;
    }
}

export interface IUserPermissionModelV2 {
    id: number | undefined;
    email: string;
    entityId: number;
    entityType: UserPermissionEntityType;
    permissionType: UserPermissionType;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}